import _toConsumableArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { useCallback } from 'react';
import { SEND_MESSAGE_USE_CASE } from '../../../../../ai';
import { getUseCase } from '@lib/plugin-redux-core';
import { useDispatch, useSelector } from 'react-redux';
import { selectSendMessageOutput, selectAttachments } from '../../../redux/ai-chat/ai-chat.selectors';
import { message } from 'antd';
import { AI_CHAT_MAX_TOTAL_FILE_SIZE_BYTES, isAiChatFileSizeValid } from '../../../../../file-management-app';
export var useUserSendMessage = function useUserSendMessage(_ref) {
  var conversationId = _ref.conversationId,
      onBuildingDataBeforeSendMessage = _ref.onBuildingDataBeforeSendMessage,
      streamCallbacks = _ref.streamCallbacks,
      onSnapshotMentionResources = _ref.onSnapshotMentionResources,
      llmConfig = _ref.llmConfig,
      extraFiles = _ref.extraFiles;
  var dispatch = useDispatch();
  var sendMessageUseCase = getUseCase(SEND_MESSAGE_USE_CASE, dispatch);
  var sendMessageOutput = useSelector(selectSendMessageOutput);
  var attachments = useSelector(selectAttachments);
  var sendMessage = useCallback(function (content) {
    var _attachments$reduce, _attachments$map, _extraFiles$map;

    if (!conversationId) return;
    var invalidAttachment = attachments === null || attachments === void 0 ? void 0 : attachments.find(function (attachment) {
      return !isAiChatFileSizeValid(attachment.size);
    });

    if (invalidAttachment) {
      message.error("\"".concat(invalidAttachment.name, "\" must have a known size smaller than 50 MB."));
      return;
    }

    var totalAttachmentSize = (_attachments$reduce = attachments === null || attachments === void 0 ? void 0 : attachments.reduce(function (total, attachment) {
      return total + (attachment.size || 0);
    }, 0)) !== null && _attachments$reduce !== void 0 ? _attachments$reduce : 0;

    if (totalAttachmentSize >= AI_CHAT_MAX_TOTAL_FILE_SIZE_BYTES) {
      message.error('The combined size of files in one message must be smaller than 50 MB.');
      return;
    } // Clean up previous subscription


    if (sendMessageOutput) {
      sendMessageOutput.unsubscribe();
    }

    var data;

    if (onBuildingDataBeforeSendMessage) {
      data = onBuildingDataBeforeSendMessage();
    }

    var internalIds = (_attachments$map = attachments === null || attachments === void 0 ? void 0 : attachments.map(function (attachment) {
      return attachment.id;
    })) !== null && _attachments$map !== void 0 ? _attachments$map : [];
    var extraIds = (_extraFiles$map = extraFiles === null || extraFiles === void 0 ? void 0 : extraFiles.map(function (file) {
      return file.id;
    })) !== null && _extraFiles$map !== void 0 ? _extraFiles$map : [];
    var mergedFileIds = Array.from(new Set([].concat(_toConsumableArray(internalIds), _toConsumableArray(extraIds))));
    var formReferenceResources = (extraFiles !== null && extraFiles !== void 0 ? extraFiles : []).map(function (file) {
      return {
        resourceType: 'form',
        resourceId: file.id
      };
    });
    var payload = {
      conversationId: conversationId,
      content: content,
      data: data,
      fileIds: mergedFileIds.length > 0 ? mergedFileIds : undefined,
      resources: formReferenceResources.length > 0 ? formReferenceResources : undefined,
      callbacks: streamCallbacks,
      llmConfig: llmConfig
    };
    sendMessageUseCase.execute(payload);

    if (onSnapshotMentionResources) {
      onSnapshotMentionResources();
    }
  }, [conversationId, sendMessageOutput, onBuildingDataBeforeSendMessage, onSnapshotMentionResources, attachments, extraFiles, sendMessageUseCase, streamCallbacks, llmConfig]);
  return {
    sendMessage: sendMessage
  };
};